/* =========================================================
	EVENTS FILTER HELPERS
	1.0 Check/uncheck categories
		https://stackoverflow.com/questions/57366772/how-to-get-the-data-attributes-of-radio-buttons-to-change-a-variable
========================================================= */

/* 1.0 Check/uncheck categories ---------------- */
const anyCheckbox = document.getElementById('any');
const typeCheckboxes = document.querySelectorAll('.type');

anyCheckbox.addEventListener('change', () => {
    if (anyCheckbox.checked) {
        typeCheckboxes.forEach(cb => cb.checked = false);
    }
});

typeCheckboxes.forEach(cb => {
	if (cb.checked) {
		anyCheckbox.checked = false;
	}

    cb.addEventListener('change', () => {
        if (cb.checked) {
            anyCheckbox.checked = false;
        }
    });
});
